import EmployerStatSummary, {
  EmployerStatSummaryDisplayProps,
} from "./EmployerStatSummary";

const EmployerActiveLeasesStat = ({
  count,
  showTitle,
  navigateOnClick,
  config,
}: {
  count: number;
} & EmployerStatSummaryDisplayProps) => {
  return (
    <EmployerStatSummary
      title="Active Leases"
      imageUrl="/analytics/car.png"
      value={`${count}`}
      page="employerViewAnalyticsActiveLeases"
      showTitle={showTitle}
      navigateOnClick={count > 0 ? navigateOnClick : undefined}
      config={config}
    />
  );
};

export default EmployerActiveLeasesStat;
